import React from "react";
import { Tag } from "lucide-react";

/**
 * Phase 25b · Clickable category chip cloud with facet counts.
 */
export function MarketplaceCategoryChips({ items = [], active, onSelect }) {
  if (!items || items.length === 0) return null;
  return (
    <section data-testid="mp-categories-chips" className="space-y-3">
      <header>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-text-secondary mb-1">
          <Tag className="h-3 w-3 text-[var(--color-secondary)]" /> Browse by category
        </div>
      </header>
      <div className="flex flex-wrap gap-2">
        <button
          data-testid="mp-category-chip-all"
          onClick={() => onSelect(null)}
          className={`text-xs px-3 py-1.5 rounded-full uppercase tracking-widest border transition-colors ${
            !active
              ? "border-[var(--color-primary)] bg-[var(--color-primary)]/15 text-[var(--color-primary)]"
              : "border-[var(--color-border)] text-text-secondary hover:border-white/20"
          }`}
        >
          All
        </button>
        {items.map((c) => (
          <button
            key={c.tag}
            data-testid={`mp-category-chip-${c.tag}`}
            onClick={() => onSelect(c.tag)}
            className={`text-xs px-3 py-1.5 rounded-full uppercase tracking-widest border transition-colors ${
              active === c.tag
                ? "border-[var(--color-primary)] bg-[var(--color-primary)]/15 text-[var(--color-primary)]"
                : "border-[var(--color-border)] text-text-secondary hover:border-white/20"
            }`}
          >
            {c.tag} <span className="text-text-secondary/70 tabular-nums">({c.count})</span>
          </button>
        ))}
      </div>
    </section>
  );
}

export default MarketplaceCategoryChips;
